export default '/build/4f954598.svg'